import { Injectable } from '@angular/core';
import * as forge from 'node-forge';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  constructor() { }

  encryptData(data: string, publicKey:any): string {
    let publicPEMKey: any = `-----BEGIN PUBLIC KEY-----${publicKey}-----END PUBLIC KEY-----`;
    const rsa = forge.pki.publicKeyFromPem(publicPEMKey);
    const encrypted = rsa.encrypt(data);
    return forge.util.encode64(encrypted);
  }
}